import request from '@/utils/request';

const DEPOSIT_OPTIONS_TIMEOUT_MS = 30000;

/** MixPay 充值能力 GET /liyuan-evm-pm/pm-chain/mixpay/onramp/supported */
export function getMixPaySupported() {
  return request.get('/liyuan-evm-pm/pm-chain/mixpay/onramp/supported', undefined, {
    timeout: DEPOSIT_OPTIONS_TIMEOUT_MS,
  });
}

/** 创建 MixPay 充值订单 POST /liyuan-evm-pm/pm-chain/mixpay/onramp/orders */
export function createMixPayOnrampOrder(data = {}) {
  return request.post('/liyuan-evm-pm/pm-chain/mixpay/onramp/orders', data);
}

/**
 * 分页查询 MixPay 充值订单
 * GET /liyuan-evm-pm/pm-chain/mixpay/onramp/orders
 */
export function getMixPayOnrampOrders(params = {}) {
  return request.get('/liyuan-evm-pm/pm-chain/mixpay/onramp/orders', params);
}

/**
 * MixPay USD→支付币估价（平台代理 MixPay payments_estimated，禁止直连）。
 * GET …/mixpay/onramp/estimate?quoteAmount&paymentSymbol
 * @param {{ quoteAmount?: number, paymentSymbol?: string }} params
 * @returns {Promise<object|null>}
 */
export function getMixPayPaymentEstimate(params = {}) {
  return request.get('/liyuan-evm-pm/pm-chain/mixpay/onramp/estimate', params, {
    timeout: DEPOSIT_OPTIONS_TIMEOUT_MS,
  });
}
